import React from 'react';
import { HiOutlinePhotograph } from 'react-icons/hi';
import './ProofPlaceholder.css';

// Stands in for a proof image WITHOUT fetching it.
//
// Proof documents are stored at full camera resolution (~3.8 MB each). Every
// list that showed a preview was downloading the original just to paint a 50px
// square — a 20-row page pulled ~77 MB, and a delivery boy's phone paid for it
// twice, since tapping the tile downloads the file again to open it. Today's
// access log: 231 proof fetches, 868 MB, against 117 MB for all other API
// traffic combined.
//
// So nothing is fetched to render this. The real image is requested only when
// the user explicitly opens it — the same click handler that was always there.
const ProofPlaceholder = ({
    className = '',
    label = 'View',
    onClick,
    title = 'Click to view image'
}) => (
    <div
        className={`proof-ph ${className}`}
        onClick={onClick}
        title={title}
        role={onClick ? 'button' : undefined}
        tabIndex={onClick ? 0 : undefined}
        onKeyDown={onClick ? (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick(e);
            }
        } : undefined}
    >
        <HiOutlinePhotograph className="proof-ph-icon" />
        {label && <span className="proof-ph-label">{label}</span>}
    </div>
);

export default ProofPlaceholder;
